import type { ReactNode } from 'react';

interface MyProfileReadonlyFieldProps {
  label: string;
  // Use a string for plain text inputs; pass `children` for richer content (Role badges).
  value?: string;
  children?: ReactNode;
}

// PRD 20 §2.1: read-only fields share the same form-field__input style with
// a #f9fafb background and a 16px margin-bottom. Children mode is used by the
// Role row, which renders badges instead of a plain input.
export function MyProfileReadonlyField({
  label,
  value,
  children,
}: MyProfileReadonlyFieldProps) {
  return (
    <div className="form-field" style={{ marginBottom: 16 }}>
      <label className="form-field__label">{label}</label>
      {children ? (
        <div
          className="form-field__input"
          style={{
            background: '#f9fafb',
            cursor: 'default',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 6,
            minHeight: 40,
            padding: '8px 12px',
          }}
        >
          {children}
        </div>
      ) : (
        <input
          type="text"
          className="form-field__input"
          style={{ background: '#f9fafb', cursor: 'default' }}
          value={value ?? ''}
          readOnly
        />
      )}
    </div>
  );
}
